import React from 'react';
import { Skeleton, TableBody, TableRow } from '@mui/material';
import { TableCellStyled, TableCellNameStyled } from './ConnectionsTable.styles';

const COLUMN_COUNT = 6;

type ConnectionsTableLoadingProps = {
  rowsPerPage: number;
};

export const ConnectionsTableLoading = ({ rowsPerPage }: ConnectionsTableLoadingProps) => (
  <TableBody>
    {Array.from({ length: rowsPerPage }, (_, index) => (
      <TableRow key={index}>
        <TableCellNameStyled>
          <Skeleton />
        </TableCellNameStyled>
        {Array.from({ length: COLUMN_COUNT - 1 }, (__, colIndex) => (
          <TableCellStyled key={colIndex}>
            <Skeleton />
          </TableCellStyled>
        ))}
      </TableRow>
    ))}
  </TableBody>
);
